<template>
  <div id="mask"  @click="close()" ref="" v-if="show" >
    <div class="award"
      :style="{
        'backgroundImage' : 'url(' + config.popup_bg + ')',
        'backgroundSize': '100% 100%'
      }"
       v-on:click.stop>
      <div class="img-container" v-if="award.reward_image">
        <img :src="award.reward_image" alt="">
      </div>
      <div class="desc"
        :style="{
          'color': config.award_tip_color
        }"
      >{{award.reward_msg}}</div>
      <div class="close-btn"  @click="close()"></div>
      <div class="sign-btn"  v-if="config.show_game_btn"
        :style="{
          'backgroundImage' : 'url(' + config.game_btn + ')',
          'backgroundSize': '100% 100%'
        }"
       ><a :href="config.game_link"></a></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'toast',
  props: {
    award: {},
    show: false,
    config: {},
  },

  methods: {
    close() {
      this.$emit('update:show', false)
    },
  },
}
</script>

<style lang="scss" src="./customToast.scss" scoped></style>
